import React from 'react';
import C18Button00 from './C18Button00'
import {checkConnected} from './C18utils'
import {cl,globs,getTime} from '../../components/utils/utils';

class C18SaveHeader00 extends React.Component{
  constructor(props) {
    super(props);
    let pr=props
//     cl(props)
//     cl(globs)
//     cl(globs.contacts)
    this.state={
      saveEnable: false,
      saving: false,
      failing: false,// on save error
      connected: true,//this.checkConnected(),
      reloading: false,
      csv: false,
    }
    this.dark=((globs.device?.deviceTheme||"").toLowerCase().indexOf("dark")>=0)?1:0
    this.subscribe_savePageEnable=globs.events.subscribe("savePageEnable",this.enDisSave)
    this.subscribe_saveOK=globs.events.subscribe("saveOK",this.saveOK)
    this.subscribe_keyUp=globs.events.subscribe("keyUp",this.keyUp)
    this.subscribe_toClient=globs.events.subscribe("toClient",this.toClient)
    this.connectInt=setInterval(e=>{
//       cl("check")
      this.setState({connected:checkConnected(pr.site,pr.zInd)})
    },10000)
  }

//   checkConnected=(site,zInd)=>{
//     let pr=this.props
//     if(pr.zInd==undefined){return true}
//     if(globs.contacts){
//       let now=getTime()
//       let contact=globs.contacts[pr.site][pr.zInd]
//       let connected=(now-contact)<120
//       this.setState({connected:connected})
// //     cl(contact)
//     }
//   }
  
  componentWillUnmount=()=>{
    this.subscribe_savePageEnable.remove()
    this.subscribe_saveOK.remove()
    this.subscribe_keyUp.remove()
    this.subscribe_toClient.remove()
    clearInterval(this.connectInt)
  }

  toClient=(cmd)=>{
//     cl(cmd)
    if((cmd.type=="NACK")&&(cmd.data=="mutex: guiTask")){
      cl("set inMenu")
      this.setState({saving:false,failing:false,inMenu:true})
    }
  }
  
  keyUp=(e)=>{
//     cl(key)
    let key=e.key
    if((this.state.saveEnable)&&(key=="Enter")){this.onClick("save")}
  }
  
  enDisSave=(val)=>{
//     cl("msg")
//     cl(val)
    this.setState({saveEnable:val})
    this.props.onChange({saveEnable:val})
  }
  
  saveOK=()=>{
//     cl("save ok")
//     cl("C18SaveHeader, doing saveOK")
    clearTimeout(this.slideTimer)
    this.props.onChange({saveEnable:false})
    this.setState({saving: false, failing: false, saveEnable: false, inMenu:false})
    globs.events.publish("PageSavedSuccessfully")
//     cl("C18SaveHeader saveOK Done")
  }
  
  clearSlideIn=()=>{
    cl("clearSlideIn")
    this.setState({saving: false, failing: true, inMenu:false})
  }

  clearSlideInReload=()=>{
    cl("clearSlideInReload")
    this.setState({reloading: false})
  }

  clearSlideInCsv=()=>{
    cl("clearSlideInCsv")
    this.setState({csv: false})
  }
  
  onClick=(type)=>{
//     cl(type)
    switch(type){
      case "save":
        this.setState({saving:true,failing:false,inMenu:false,saveEnable:false})
//         this.props.onChange({saveEnable:false})// removed 20260927
        this.slideTimer=setTimeout(this.clearSlideIn,this.props.saveTimeout||35000)
        globs.events.publish("savePageEvent",type)
        break
      case "reload":
        // cl("reload")
        // show reload slide
        this.setState({reloading:true})
        globs.events.publish("reloadPage")
        this.slideTimer=setTimeout(this.clearSlideInReload,1000)
        break
      case "copyCSV":
        this.setState({csv:true})
        globs.events.publish("copyCSV")
        this.slideTimer=setTimeout(this.clearSlideInCsv,1000)
        break
      default:
        cl("***********************reload")
        window.location.reload()
        break
    }
  }
  
  render(){
    var showButtons=()=>{
//       cl(st.connected)
      let reloadCode=this.props?.parms?.reloadCode||"cancel"
//       cl(this.props)
//       cl(reloadCode)
      if(st.connected||(globs.userData?.session?.groupId)){
        return(
          <>
            {reloadCode !== "cancel" &&
            <C18Button00 type="button" className="small" onClick={o=>this.onClick("copyCSV")}>
              CSV
            </C18Button00>
            }
            <C18Button00 style={this.dark ? {color:"white"}: {}} type="button" className="small" onClick={o=>this.onClick(reloadCode)} translate='yes'>
              Reload
            </C18Button00>
            <C18Button00 type="button" className="small filled" disabled={disable} onClick={o=>this.onClick("save")} translate='yes'>
              Save
            </C18Button00>
          </>
        )
      }else{
        return(
          <div style={{fontSize:24,color:"#FF0000"}}>Disconnected</div>
        )
      }
    }
//     cl(this.state)
    let st=this.state
    let disable=!st.saveEnable
    return(
      <div id="save-header">
        <div className="save-cancel-box float-right-box">
        {showButtons()}
          <div className="clearfloat"></div>
          <div id="save-notification-slideout" className={
            `${(this.state.saving)?"open":""}`}>
            &nbsp;&nbsp;&nbsp;Saving. . .
          </div>
          <div id="error-notification-slideout" className={
            `${(this.state.failing)?"open":""}`}>
            &nbsp;&nbsp;&nbsp;Error - Not Saved!
          </div>
          <div id="error-notification-slideout" className={
            `${(this.state.inMenu)?"open":""}`}>
            &nbsp;&nbsp;&nbsp;Error - In Menu!
          </div>
          <div id="save-notification-slideout" className={
            `${(this.state.reloading)?"open":""}`}>
            &nbsp;&nbsp;&nbsp;Reloading. . .
          </div>
          <div id="save-notification-slideout" className={
            `${(this.state.csv)?"open":""}`}>
            &nbsp;&nbsp;&nbsp;Copied to clipboard!
          </div>
        </div>
        <div className="clearfloat"></div>
      </div>
    )
  }
}
      
export default C18SaveHeader00;
